import zwitCore from "zw-core";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
export default {
  login(data) {
    // console.log(data);
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/login", data, false);
  },
  getCode(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/sms/sendNew", data, false);
  },
  reg(data) {
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/register/user", data, false);
  },
  logOut() {
    return zwitCore.HTTP.json(BASE_URL + "/zw-user/logout");
  },
  sonLogin(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/subUser/nf/login",
      data,
      false
    );
  },
  getclause() {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/nf/termsOfUse", {}, false);
  },
  repwd(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/reset/nf/userRetrievePwd",
      data,
      false
    );
  },
  getUserInfo() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-user/nf/getloginInfo", {}, false);
  },

  // 获取公网ip地址接口
  async getUserIpConfig() {
    const isValidIp = (ip) => {
      if (!ip) return false;
      // 兼容 IPv4 / IPv6 的基础校验，避免写入空值或异常值
      return /^(?:\d{1,3}\.){3}\d{1,3}$/.test(ip) || /^[0-9a-fA-F:]+$/.test(ip);
    };

    const services = [
      { url: 'https://api.ipify.org?format=json', key: 'ip' },
      { url: 'https://api.ip.sb/geoip', key: 'ip' },
      { url: 'https://ipwho.is/', key: 'ip' },
    ];

    for (const service of services) {
      try {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 3500);
        const response = await fetch(service.url, {
          method: 'GET',
          signal: controller.signal,
        });
        window.clearTimeout(timer);

        if (!response.ok) continue;

        const data = await response.json();
        const ip = data?.[service.key];
        if (isValidIp(ip)) {
          return ip;
        }
      } catch (error) {
        // 单个免费服务失败时继续尝试下一个
        continue;
      }
    }

    return '';
  },
};
